module.exports = __webpack_public_path__ + "static/media/active-balancer.969d0b68.png";